module.exports = __webpack_public_path__ + "static/media/Viktor.f16fc64c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/fonts/Viktor.otf
// module id = 1514
// module chunks = 0